import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import PartnerDashboard from './pages/PartnerDashboard';
import AdminDashboard from './pages/AdminDashboard';
import PartnersAndProfitsPage from './pages/PartnersAndProfitsPage';
import SettingsPage from './pages/SettingsPage';
import { Toaster } from './components/ui/sonner';
import './App.css';

function AppRouter({ isAuthenticated, userRole, partnerId, onLogin, onLogout }) {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route 
        path="/login" 
        element={
          isAuthenticated ? 
            <Navigate to={userRole === 'admin' ? '/admin' : '/partner'} /> : 
            <Login onLogin={onLogin} />
        } 
      />
      <Route 
        path="/partner" 
        element={
          isAuthenticated && userRole === 'partner' ? 
            <PartnerDashboard partnerId={partnerId} onLogout={onLogout} /> : 
            <Navigate to="/login" />
        } 
      />
      <Route 
        path="/admin" 
        element={
          isAuthenticated && userRole === 'admin' ? 
            <AdminDashboard onLogout={onLogout} /> : 
            <Navigate to="/login" />
        } 
      />
      <Route 
        path="/partners" 
        element={
          isAuthenticated && userRole === 'admin' ? 
            <PartnersAndProfitsPage /> : 
            <Navigate to="/login" />
        } 
      />
      <Route 
        path="/admin/settings" 
        element={
          isAuthenticated && userRole === 'admin' ? 
            <SettingsPage /> : 
            <Navigate to="/login" />
        } 
      />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [partnerId, setPartnerId] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const role = localStorage.getItem('role');
    const pId = localStorage.getItem('partner_id');
    
    if (token && role) {
      setIsAuthenticated(true);
      setUserRole(role);
      setPartnerId(pId);
    }
  }, []);

  const handleLogin = (token, role, username, partner_id = null) => {
    localStorage.setItem('token', token);
    localStorage.setItem('role', role);
    localStorage.setItem('username', username);
    if (partner_id) {
      localStorage.setItem('partner_id', partner_id);
      setPartnerId(partner_id);
    }
    setIsAuthenticated(true);
    setUserRole(role);
  };

  const handleLogout = () => {
    localStorage.clear();
    setIsAuthenticated(false);
    setUserRole(null);
    setPartnerId(null);
  };

  return (
    <div className="App" dir="rtl" lang="ar">
      <BrowserRouter>
        <AppRouter 
          isAuthenticated={isAuthenticated}
          userRole={userRole}
          partnerId={partnerId}
          onLogin={handleLogin}
          onLogout={handleLogout}
        />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
